import {TAXPAYER_BRANCH_DEVICE_STATUS} from '../../../actionType';

//taxpayerStatus = true表示正常（纳税人状态为NORMAL），反之为false
//branchStatus = true表示正常（分支状态为NORMAL），反之为false
//einvoiceStatus = true表示einvoice未注销，已注销为false
//deviceStatus = true表示有设备未注销，全部设备已注销为false

export default function (state = {taxpayerStatus: true,
                             branchStatus : true,
                             einvoiceStatus : true,
                             deviceStatus : true}, action) {
    switch (action.type) {
        case TAXPAYER_BRANCH_DEVICE_STATUS:
            return {
                ...state,
                taxpayerStatus: action.taxpayerStatus,
                branchStatus : action.branchStatus,
                einvoiceStatus : action.einvoiceStatus,
                deviceStatus : action.einvoiceStatus
            };
        default:
            return state;
    }
}
